import PropTypes from 'prop-types';
import { injectIntl, intlShape } from '@edx/frontend-platform/i18n';
import MessageBubble from './MessageBubble';
import { Button, Icon } from '@blend-ed/blendx-ui';
import messages from '../../messages';

function MessageGroup({ message, onSuggestionClick, onExpandView, intl, isLastMessage, handleLearnerLearningPath }) {
  return (
    <div className="message-group">
      <MessageBubble
        message={message}
        onExpandView={onExpandView}
        isLastMessage={isLastMessage}
        isNewMessage={message.isNewMessage}
        handleLearnerLearningPath={handleLearnerLearningPath}
      />
      {message.type === 'ai' && message.generatedLearningPath && (
        <div className="suggestions-grid small">
          <Button
            key={message.id}
            variant="outline-gray"
            size="xs"
            className="suggestion-button"
            onClick={() => {
              onSuggestionClick(intl.formatMessage(messages.suggestTopic), "suggest-topic");
              handleLearnerLearningPath(message.generatedLearningPath);
            }}
            leftIcon={<Icon icon="book-open" type="line" />}
          >
            {intl.formatMessage(messages.suggestTopic)}
          </Button>
        </div>
      )}
    </div>
  );
}

MessageGroup.propTypes = {
  message: PropTypes.object.isRequired,
  intl: intlShape.isRequired,
  onSuggestionClick: PropTypes.func.isRequired,
  onExpandView: PropTypes.func.isRequired,
  isLastMessage: PropTypes.bool.isRequired,
  handleLearnerLearningPath: PropTypes.func.isRequired,
};

export default injectIntl(MessageGroup); 